export default {
  title: 'Secret de signature du webhook',
  warning:
    "Enregistrez ce secret maintenant — il ne sera plus affiché. Utilisez-le pour vérifier l'en-tête X-Webhook-Signature.",
  done: 'Terminé',
};
